import { useEffect, useState } from 'react';
import { StatusBar, Style } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';
import { isNative, getPlatform, registerPushNotifications, onNetworkChange } from '../services/mobile';

export function useMobile() {
  const [isOnline, setIsOnline] = useState(true);
  const [pushToken, setPushToken] = useState<string | null>(null);
  const platform = getPlatform();
  const native = isNative();

  useEffect(() => {
    if (!native) return;

    async function init() {
      // Style status bar dark for light backgrounds
      await StatusBar.setStyle({ style: Style.Dark });

      // Hide the splash screen after the app shell is ready
      await SplashScreen.hide();

      // Register for push notifications and store the device token
      const token = await registerPushNotifications();
      if (token) setPushToken(token);
    }

    init();

    onNetworkChange(setIsOnline);
  }, [native]);

  return { platform, native, isOnline, pushToken };
}
